import { FC, ComponentProps } from 'react';

import TimeslotWidget from '../../timeslotWidget';
import BookingSlots from '../../bookingSlots';

import ClosedSlot from './closedSlot';

import { isClosed } from '../../../utils/booking';
import { i18n as I18n } from '../../../utils/i18n';

type TimeslotWidgetProps = ComponentProps<typeof TimeslotWidget>;
type BookingSlotsProps = ComponentProps<typeof BookingSlots>;

interface OpeningTimes {
  [key: string]: string;
}

interface Closure {
  startDate: string;
  endDate: string;
}

// FIXME: This doesn't work with babel
// interface Space extends Required<BookingSlotsProps>['spaces'][number]
interface Space {
  id: number;
  openingTimes: OpeningTimes;
}

interface Venue {
  openingTimes: OpeningTimes;
  closures: Closure[];
}

interface Props extends TimeslotWidgetProps, BookingSlotsProps {
  date: string;
  venue: Venue;
  spaces?: Space[];
  clinical: boolean;
}

const SlotsField: FC<Props> = ({ clinical, date, venue = {}, ...props }) => {
  const { startTime, endTime, spaces = [], slots = [] } = props;

  if (
    !startTime ||
    !endTime ||
    isClosed(date, venue.openingTimes, venue.closures) ||
    spaces.some(space => isClosed(date, space.openingTimes))
  )
    return <ClosedSlot />;

  if (clinical && slots.length === 0)
    return (
      <ClosedSlot label={I18n.t('quick_book.timeslot_widget.unavailable')} />
    );

  return clinical ? <BookingSlots {...props} /> : <TimeslotWidget {...props} />;
};

export default SlotsField;
